<!-- contact area start -->
<vb-breadcrumb-one title="Contact Us" [disableTitle]="true"></vb-breadcrumb-one>

<section class="mt-4 mb-4">
    <div class="container-fluid">
      <div>
          <vb-contact-us
              [roles]="roles"
              [subjects]="subjects"
              [sent]="sent"
              (sentChange)="onSentChange($event)"
              (submitted)="onSubmitted($event)"
          ></vb-contact-us>
      </div>
    </div>
    <div class="container-fluid mt-50 mb-50" *ngIf="currentUserId">
        <vb-newsletter-subscription-form></vb-newsletter-subscription-form>
    </div>
</section>
